module.exports = __webpack_public_path__ + "751902657c103325e06e5c4f27784609.MP3";